import { IconName } from '@sc/data-access-assets';

export interface SplitButton {
  label?: string;
  icon?: IconName;
  action: () => void;
}
